import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { SearchInput } from '@tfo/common'

import './ReportsSearch.scss'
import RootStore from '../../../../../../stores/RootStore'
import { useIntl } from 'react-intl'

export interface ReportsSearchProps {
	rootStore?: RootStore
}

class ReportsSearch extends React.Component<
	React.HTMLAttributes<HTMLDivElement> & ReportsSearchProps
> {
	keyListener: any
	private store: RootStore
	

	constructor(props: ReportsSearchProps) {
		super(props)
		this.store = props.rootStore!
		
		const onKeyUp = (e: KeyboardEvent) => {
			if (e.code == 'Escape') {
				this.store.clientViewStore.reportsStore.searchString = ''
			}
		}
		this.keyListener = onKeyUp.bind(this)
	}
	componentWillMount(): void {
		window.addEventListener('keyup', this.keyListener)
	}
	componentWillUnmount() {
		window.removeEventListener('keyup', this.keyListener)
	}
	
	
	render() {
		const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			this.store.clientViewStore.reportsStore.searchString = e.target.value
		}
		const onClear = () => {
			this.store.clientViewStore.reportsStore.searchString = ''
		}
		return (
			<div className="ReportsSearch">
				<SearchInput
					value={this.store.clientViewStore.reportsStore.searchString || ''}
					onInputChange={onChange}
					onClear={onClear}
				/>
			</div>
		)
	}
}

export default inject('rootStore')(observer(ReportsSearch))
